import React from "react";
import { IntlProvider } from 'react-intl';
import { Provider as EufemiaProvider } from '@dnb/eufemia/shared';
import { useLanguage } from '@dnb/locale';
import HeaderControlsNoWrapper from './components/HeaderControls/HeaderControls';
import { translations } from './i18n';
import {createHeadroomHook} from "./hooks/UseHeadroom/useHeadroom";
import { getAuthenticationState } from '@dnb/authentication';
import styles from "./HeaderControlsWrapper.module.scss";

const useHeadroom = createHeadroomHook();

export default function HeaderControlsWrapper () {
  const { locale } = useLanguage();
  const { isLoggedIn } = getAuthenticationState();
  const { headroomRef, shouldOpenChildren } = useHeadroom({});

  return (
    <IntlProvider locale={locale} messages={translations[locale]} >
      <EufemiaProvider locale={locale}>
        <div ref={headroomRef} className={styles.headerControlsWrapper}>
          <HeaderControlsNoWrapper isLoggedIn={isLoggedIn} shouldOpen={shouldOpenChildren} />
        </div>
      </EufemiaProvider>
    </IntlProvider>
  );
}

HeaderControlsWrapper.displayName = 'HeaderControls';
